import gql from 'graphql-tag'

export const USER_REPAIR_ITEMS = gql`{
  myRepairItems {
    id
    confirmationCode
    createdAt
    formattedPrice
    material
    brand
    color
    photoUrl
    apparel {
      id
      name
    }
    ticket {
      id
      status
    }
    options {
      id
      name
      category {
        id
        name
      }
    }
  }
}`

export const SINGLE_REPAIR_ITEM = gql`
  query RepairItem($id: String!)
  {
    repairItem(id: $id) {
      id
      description
      photoUrl
      confirmationCode
      createdAt
      formattedPrice
      material
      brand
      color
      isRush
      apparel {
        name
      }
      options {
        formattedPrice
        minPrice
        maxPrice
        indefiniteMax
        id
        name
        comment
        category {
          name
        }
      }
    }
    # errors
  }
`
